import { Box, Grid2 as Grid, Typography } from "@mui/material";
import { green, red } from "@mui/material/colors";
import CancelIcon from "@mui/icons-material/Cancel";
import { LoadingButton } from "@mui/lab";
import { convertObjectDateToUSString } from "../../notary/functions";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import axios from "axios";
import { useState } from "react";
import { useSelector } from "react-redux";
import ChangeNotaryModal from "../../modals/ChangeNotaryModal";

const OwnerSignerTab = ({ selectedRow, isReadOnlyPage = false }) => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession]?.user);

  const [rescheduleLoading, setRescheduleLoading] = useState(false);
  const [changeNotaryOpen, setChangeNotaryOpen] = useState(false);

  const notarizationData = selectedRow?.processing_permit?.notarization || {};
  const { contractor = {}, owner = {}, signing_order } = notarizationData;
  const notarization = notarizationData;

  // Check if owner notarization is IPEN
  const isOwnerIpen = owner?.notarization?.is_ipen === true;
  const canChangeOwnerIpenNotary =
    isOwnerIpen &&
    owner?.notarization?.has_notary &&
    !owner?.notarization?.is_notarized &&
    owner?.notarization?.bn_id;

  const handleSendRescheduleLink = async () => {
    try {
      setRescheduleLoading(true);

      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/notary/send-owner-ron-reschedule-link`,
        {
          task_id: selectedRow?.task_id,
          bn_id:
            selectedRow?.processing_permit?.notarization?.owner?.notarization
              ?.bn_id,
          currentSession: currentSession,
        },
        {
          withCredentials: true,
        },
      );
    } catch (error) {
    } finally {
      setRescheduleLoading(false);
    }
  };

  // const handleRefreshOwnerSignOnly = async () => {
  //   try {
  //     setRefreshLoading(true);
  //     const resp = await axios.post(
  //       `${process.env.REACT_APP_BASE_URL}/nocApi/notary/refresh-owner-sign`,
  //       {
  //         task_id: selectedRow?.task_id,
  //         currentSession: currentSession,
  //       },
  //       {
  //         withCredentials: true,
  //       }
  //     );
  //     if (resp.data.success === true) {
  //       // Refresh successful, component will re-render with updated data
  //     }
  //   } catch (e) {
  //     // Handle error silently or show notification
  //   } finally {
  //     setRefreshLoading(false);
  //   }
  // };

  const renderLogs = () => {
    // For IPEN, show simplified single session status
    if (isOwnerIpen) {
      const notaryJoined =
        owner?.notarization?.logs?.[owner?.notarization?.attempt]
          ?.notary_joined;
      const ownerJoined =
        owner?.notarization?.logs?.[owner?.notarization?.attempt]?.owner_joined;
      const sessionStarted = notaryJoined && ownerJoined;

      return (
        <>
          <Grid size={{ sm: 10 }}>
            <Typography variant="body2" fontWeight="bold">
              IPEN session has been started
            </Typography>
          </Grid>
          <Grid size={{ sm: 2 }} align="right">
            {notaryJoined ? (
              <CheckCircleIcon
                style={{
                  color: green[500],
                }}
              />
            ) : (
              <CancelIcon style={{ color: red[500] }} />
            )}
          </Grid>
          {canChangeOwnerIpenNotary && !isReadOnlyPage && (
            <Grid size={{ sm: 12 }} sx={{ mt: 1 }}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <LoadingButton
                  variant="outlined"
                  onClick={() => setChangeNotaryOpen(true)}
                >
                  Change Notary
                </LoadingButton>
              </Box>
            </Grid>
          )}
          {owner?.notarization?.logs?.[owner?.notarization?.attempt]
            ?.owner_joined && (
            <Grid size={{ sm: 10 }}>
              <Typography variant="body2" fontWeight="bold">
                {owner?.notarization?.logs?.[owner?.notarization?.attempt]
                  ?.id_passed
                  ? "ID Verification Passed"
                  : owner?.notarization?.logs?.[owner?.notarization?.attempt]
                        ?.id_failed
                    ? "ID Verification Failed"
                    : "Waiting for ID Verification..."}
              </Typography>
            </Grid>
          )}
          {owner?.notarization?.logs?.[owner?.notarization?.attempt]
            ?.id_passed && (
            <Grid size={{ sm: 2 }} align="right">
              <CheckCircleIcon
                style={{
                  color: green[500],
                }}
              />
            </Grid>
          )}
          {owner?.notarization?.logs?.[owner?.notarization?.attempt]
            ?.id_failed && (
            <Grid size={{ sm: 2 }} align="right">
              <CancelIcon style={{ color: red[500] }} />
            </Grid>
          )}
          {sessionStarted && (
            <Grid size={{ sm: 12 }}>
              <Typography variant="body2" fontWeight="bold">
                Signing In Progress...
              </Typography>
            </Grid>
          )}
        </>
      );
    }

    // For RON, show the original detailed logs
    return (
      <>
        <Grid size={{ sm: 10 }}>
          <Typography variant="body2" fontWeight="bold">
            Notary Joined to the session
          </Typography>
        </Grid>
        <Grid size={{ sm: 2 }} align="right">
          {owner?.notarization?.logs?.[owner?.notarization?.attempt]
            ?.notary_joined ? (
            <CheckCircleIcon
              style={{
                color: green[500],
              }}
            />
          ) : (
            <CancelIcon style={{ color: red[500] }} />
          )}
        </Grid>
        <Grid size={{ sm: 10 }}>
          <Typography variant="body2" fontWeight="bold">
            Owner/Agent Joined to the session
          </Typography>
        </Grid>
        <Grid size={{ sm: 2 }} align="right">
          {owner?.notarization?.logs?.[owner?.notarization?.attempt]
            ?.owner_joined ? (
            <CheckCircleIcon
              style={{
                color: green[500],
              }}
            />
          ) : (
            <CancelIcon style={{ color: red[500] }} />
          )}
        </Grid>
        <Grid size={{ sm: 10 }}>
          <Typography variant="body2" fontWeight="bold">
            {owner?.notarization?.logs?.[owner?.notarization?.attempt]
              ?.owner_joined
              ? owner?.notarization?.logs?.[owner?.notarization?.attempt]
                  ?.id_passed
                ? "ID Verification Passed"
                : owner?.notarization?.logs?.[owner?.notarization?.attempt]
                      ?.id_failed
                  ? "ID Verification Failed"
                  : "Waiting for ID Verification..."
              : ""}
          </Typography>
        </Grid>
        <Grid size={{ sm: 2 }} align="right">
          {owner?.notarization?.logs?.[owner?.notarization?.attempt]
            ?.id_passed ? (
            <CheckCircleIcon
              style={{
                color: green[500],
              }}
            />
          ) : owner?.notarization?.logs?.[owner?.notarization?.attempt]
              ?.id_failed ? (
            <CancelIcon style={{ color: red[500] }} />
          ) : (
            <></>
          )}
        </Grid>
        {owner?.notarization?.logs?.[owner?.notarization?.attempt]
          ?.owner_joined &&
          owner?.notarization?.logs?.[owner?.notarization?.attempt]
            ?.notary_joined && (
            <Grid size={{ sm: 12 }}>
              <Typography variant="body2" fontWeight="bold">
                Signing In Progress...
              </Typography>
            </Grid>
          )}
      </>
    );
  };

  return (
    <Box>
      {!selectedRow?.processing_permit?.notarization ? (
        <Typography
          px={2}
          mt={2}
          align="center"
          variant="body2"
          fontWeight="bold"
          color="primary"
        >
          Notarization has not been initiated for this package yet.
        </Typography>
      ) : (
        <>
          {signing_order === "contractor" &&
          !contractor?.notarization?.is_notarized === true &&
          !contractor?.notarization?.is_signed === true ? (
            <Typography
              variant="body2"
              color="primary"
              align="center"
              fontWeight="bold"
              px={1}
              mt={2}
            >
              Please wait for the contractor's notarization/signing to complete.
            </Typography>
          ) : (signing_order === "contractor" &&
              contractor?.notarization?.is_notarized) ||
            contractor?.notarization?.is_signed ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h6"
                  color="primary"
                  align="center"
                  fontWeight="bold"
                  px={1}
                  mt={1}
                >
                  {!owner?.notarization?.is_notarized &&
                  !owner?.notarization?.only_sign
                    ? "Notarization is in progress"
                    : owner?.notarization?.is_notarized &&
                        !owner?.notarization?.only_sign
                      ? "Notarization is completed"
                      : owner?.notarization?.only_sign &&
                          !owner?.notarization?.is_signed
                        ? "Signing is in progress"
                        : "Signing is completed"}
                </Typography>
                {owner?.notarization?.is_notarized && (
                  <CheckCircleIcon
                    style={{
                      color: green[500],
                      paddingTop: 4,
                      fontSize: "30px",
                    }}
                  />
                )}
              </Box>
              {!notarization?.finalized &&
              owner?.notarization?.only_sign &&
              !owner?.notarization?.is_signed ? (
                <>
                  <Typography
                    variant="body2"
                    color="primary"
                    align="center"
                    fontWeight="bold"
                    px={1}
                    mt={2}
                  >
                    The invitation email has been successfully sent to the
                    owner/agent, providing clear instructions to review and sign
                    the required documents promptly.
                  </Typography>
                  <Typography
                    variant="body2"
                    color="primary"
                    align="center"
                    fontWeight="bold"
                    px={1}
                    mt={2}
                  >
                    Please wait for the owner/agent to complete the signing
                    process.
                  </Typography>
                </>
              ) : !notarization?.finalized && !notarization?.both_only_sign ? (
                <Grid
                  sx={{ width: "100%" }}
                  container
                  spacing={0.5}
                  px={2}
                  mt={1}
                >
                  <Grid size={{ lg: 10, sm: 10 }}>
                    <Typography variant="body2" fontWeight="bold">
                      {isOwnerIpen && owner?.notarization?.require_ipen_pin
                        ? "IPEN PIN has been sent by email"
                        : isOwnerIpen && !owner?.notarization?.require_ipen_pin
                          ? "A confirmation email has been sent"
                          : "The invitation email has been sent"}
                    </Typography>
                    {owner?.reg_email && owner?.reg_mobile && (
                      <>
                        <Typography mt={-0.5} variant="body2">
                          {owner?.reg_email}
                        </Typography>
                        <Typography mt={-0.5} variant="body2">
                          {owner?.reg_mobile}
                        </Typography>
                      </>
                    )}
                  </Grid>
                  <Grid
                    size={{ lg: 2, sm: 2 }}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                    align="right"
                  >
                    <CheckCircleIcon
                      style={{
                        color: green[500],
                      }}
                    />
                  </Grid>
                  {/* Only show RON Session Scheduled if not IPEN */}
                  {!isOwnerIpen && (
                    <>
                      <Grid
                        size={{
                          sm: owner?.notarization?.waiting_to_schedule ? 10 : 6,
                        }}
                        sx={{ width: "100%" }}
                      >
                        <Typography variant="body2" fontWeight="bold">
                          RON Session Scheduled
                        </Typography>
                      </Grid>

                      <Grid
                        size={{
                          sm: owner?.notarization?.waiting_to_schedule ? 2 : 6,
                        }}
                        align="right"
                      >
                        {owner?.notarization?.waiting_to_schedule ? (
                          <CancelIcon style={{ color: red[500] }} />
                        ) : (
                          <Typography
                            variant="body2"
                            align="right"
                            fontWeight="bold"
                          >
                            {convertObjectDateToUSString(
                              owner?.notarization?.appointments?.booked?.[0],
                              currentUser?.user?.personal?.[0]?.timezone,
                            )}
                          </Typography>
                        )}
                      </Grid>
                    </>
                  )}
                  {!owner?.notarization?.waiting_to_schedule &&
                    !owner?.notarization?.only_sign &&
                    renderLogs()}
                </Grid>
              ) : (
                <Typography
                  px={2}
                  mt={2}
                  align="center"
                  variant="body2"
                  fontWeight="bold"
                  color="primary"
                >
                  All documents have been successfully notarized/signed by the
                  Owner/Agent.
                </Typography>
              )}
            </>
          ) : !notarization?.finalized &&
            owner?.notarization?.only_sign &&
            !owner?.notarization?.is_signed ? (
            <>
              <Typography
                variant="body2"
                color="primary"
                align="center"
                fontWeight="bold"
                px={1}
                mt={2}
              >
                The invitation email has been successfully sent to the
                owner/agent, providing clear instructions to review and sign the
                required documents promptly.
              </Typography>
              <Typography
                variant="body2"
                color="primary"
                align="center"
                fontWeight="bold"
                px={1}
                mt={2}
              >
                Please wait for the owner/agent to complete the signing process.
              </Typography>
            </>
          ) : signing_order === "owner" &&
            !owner?.notarization?.is_notarized &&
            !notarization?.finalized &&
            owner?.notarization?.notary_failed &&
            !owner?.notarization?.failed_resent ? (
            <Box>
              <Typography
                px={2}
                mt={1}
                align="center"
                variant="h6"
                fontWeight="bold"
                color="error"
              >
                Remote Online Notarization Failed
              </Typography>
              <Typography px={2} align="center" color="primary" variant="body2">
                The notary was unable to connect with the signer to complete the
                notarization of the required documents. To expedite the
                rescheduling of a new appointment, you can send a reminder
                email. Click the button below to send the invitation to the
                Owner or Agent.
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <LoadingButton
                  loading={rescheduleLoading}
                  onClick={handleSendRescheduleLink}
                  variant="contained"
                >
                  Send Reschedule Email
                </LoadingButton>
              </Box>
            </Box>
          ) : !owner?.notarization?.is_notarized &&
            !notarization?.finalized &&
            !owner?.notarization?.only_sign ? (
            <Grid container spacing={0.5} px={2} mt={0}>
              <Grid size={{ lg: 10, sm: 10 }} sx={{ width: "100%" }}>
                <Typography variant="body2" fontWeight="bold">
                  {isOwnerIpen && owner?.notarization?.require_ipen_pin
                    ? "IPEN PIN has been sent by email"
                    : isOwnerIpen && !owner?.notarization?.require_ipen_pin
                      ? "A confirmation email has been sent"
                      : "The invitation email has been sent"}
                </Typography>
                {owner?.reg_email && owner?.reg_mobile && (
                  <>
                    <Typography mt={-0.5} variant="body2">
                      {owner?.reg_email}
                    </Typography>
                    <Typography mt={-0.5} variant="body2">
                      {owner?.reg_mobile}
                    </Typography>
                  </>
                )}
              </Grid>
              <Grid size={{ lg: 2, sm: 2 }} align="right">
                <CheckCircleIcon
                  style={{
                    color: green[500],
                  }}
                />
              </Grid>
              {/* Only show RON Session Scheduled if not IPEN */}
              {!isOwnerIpen && (
                <>
                  <Grid
                    size={{
                      sm: owner?.notarization?.waiting_to_schedule ? 10 : 6,
                    }}
                    sx={{ width: "100%" }}
                  >
                    <Typography variant="body2" fontWeight="bold">
                      RON Session Scheduled
                    </Typography>
                  </Grid>

                  <Grid
                    size={{
                      sm: owner?.notarization?.waiting_to_schedule ? 2 : 6,
                    }}
                    align="right"
                  >
                    {owner?.notarization?.waiting_to_schedule ? (
                      <CancelIcon style={{ color: red[500] }} />
                    ) : (
                      <Typography
                        variant="body2"
                        align="right"
                        fontWeight="bold"
                      >
                        {convertObjectDateToUSString(
                          owner?.notarization?.appointments?.booked?.[0],
                          currentUser?.user?.personal?.[0]?.timezone,
                        )}
                      </Typography>
                    )}
                  </Grid>
                </>
              )}

              {!owner?.notarization?.waiting_to_schedule &&
                !owner?.notarization?.only_sign &&
                renderLogs()}
            </Grid>
          ) : signing_order === "owner" &&
            owner?.notarization?.is_notarized &&
            !notarization?.finalized ? (
            <Typography
              px={2}
              mt={2}
              align="center"
              variant="body2"
              fontWeight="bold"
              color="primary"
            >
              The owner/agent has successfully notarized/signed the documents.
              In order to access your final documents, please complete the
              notarization/signing process as the contractor.
            </Typography>
          ) : Object.keys(
              selectedRow?.processing_permit?.notarization?.contractor,
            ).length === 0 && notarization?.finalized ? (
            <Typography
              px={2}
              mt={2}
              align="center"
              variant="body2"
              fontWeight="bold"
              color="primary"
            >
              All documents have been successfully notarized by the Owner/Agent.
            </Typography>
          ) : (
            <Typography
              px={2}
              mt={2}
              align="center"
              variant="body2"
              fontWeight="bold"
              color="primary"
            >
              All documents have been successfully notarized/signed by the
              Owner/Agent.
            </Typography>
          )}
        </>
      )}
      <ChangeNotaryModal
        open={changeNotaryOpen}
        onClose={() => setChangeNotaryOpen(false)}
        taskId={selectedRow?.task_id}
        signer="owner"
        currentNotaryId={owner?.notarization?.notary?.notary_id}
      />
    </Box>
  );
};

export default OwnerSignerTab;
